import axios, { AxiosResponse } from "axios";
import { config } from "../../contexts/UrlContext";
import { toast } from "react-toastify";
import React, { useEffect, useState , useContext} from 'react';
import { Table, Icon, Dimmer, Loader, Button, SemanticICONS, Popup, Label } from 'semantic-ui-react';
import { requestSort, SORT_ICON, SORT_ORDER } from "../../services/SortService";
import PaginationNav from "../Results/PaginationNav";
import { SettingsContext } from "../../contexts/SettingsContext";
import history from "../../History";
import { ChromePicker } from 'react-color';
import ErrorPage from "../ErrorPage/ErrorPage";
import { ITheme } from "../Interfaces/TableInterface";
import AuthContext from "../../contexts/AuthContext";
import { getRequest } from "../../services/axiosService";


function ThemeDisplay() {

    const { auth } = useContext(AuthContext);


    const [loading, setLoading] = useState<boolean>(true);
    const [themes, setThemes] = useState<any[]>([]);

    const [totalPages, setTotalPages] = useState<number>(1);
    const [activePage, setActivePage] = useState<number>(1);
    const [totalResults, setTotalResults] = useState<number>(0);

    const [sortIcon, setSortIcon] = useState<SemanticICONS>(SORT_ICON.ASC);
    const [sortOrder, setSortOrder] = useState(SORT_ORDER.ASC);
    const [currentSortName, setCurrentSortName] = useState<string>("");

    const { hasAdminPrivileges } = useContext(SettingsContext);

    useEffect(() => {
        async function getData() {
             await getThemes(1);
            setLoading(false);
        }
        getData();
    }, [])

    const getThemes = async (page: number) => {
        try {
            setLoading(true);
            let query = `/Theme/GetThemeDisplay?page=${page.toString()}`;

            let response: AxiosResponse = await getRequest(auth, query);

            if (response) {
                let data = response.data;
                if (data !== null) {
                    setThemes(data.results);
                    setTotalPages(data.totalPages);
                    setTotalResults(data.totalResults);
                    setActivePage(page);
                }
                setLoading(false);
            }
        } catch (e) {
            console.log(e);
            setLoading(false);
            toast.error(`Unable to get CM2WebShare Themes. Please see logs for more info`);
        }
    }

    const handlePaginationChange = async (activePage: number) => {
        setLoading(true);
        setActivePage(activePage);
        await paginateResults(activePage);
        // scroll to top of page
        let mainDiv: any = document.getElementById('site-content');
        mainDiv.scrollTop = 0;
        setLoading(false);
    }

    const paginateResults = async (currentPage: number) => {
        await getThemes(currentPage);
    }


    const deleteTheme = async (id: string) => {
        try {
            let response: AxiosResponse;

            if (!auth || auth === null) {
                response = await axios.post(`${config.baseUrl}/api/Theme/DeleteTheme`,
                    null, {
                    params: {
                        id,
                    }
                });
            } else {
                let header = {
                    Authorization: `Bearer ${auth.user?.access_token}`,
                }
                response = await axios.post(`${config.baseUrl}/api/Theme/DeleteTheme`,
                    null, {
                    params: {
                        id,
                    },
                    headers: header
                });
            }
            let newThemes = themes.filter((theme: any) => theme.id !== id);
            setThemes(newThemes);
            setTotalResults(totalResults - 1);
            toast.success(`Theme successfully deleted`);
        } catch (error) {
            console.log(error);
            toast.error(`Unable to delete theme. Please check logs`);
        }
    }

    if (loading) {
        return (
            <Dimmer inverted active={true}>
                <Loader inverted>Loading Themes...</Loader>
            </Dimmer>
        );
    }
    else if (!hasAdminPrivileges) {
        return (
            <ErrorPage title="Access Denied" message="Only Administrators and Records Managers can view this page" />
        )
    } else {
        return (
            <div className="ui container" id="theme-home">     
                <div className="header blue headerStyleBlue" style={{marginTop:20}}>Table Themes Created</div>
                <div style={{ marginLeft: 10 }}>Total Results: {totalResults}</div>
                <Table id="homeTable" style={{ marginLeft: 10 }}>
                    <Table.Header>
                        <Table.Row>
                            <Table.HeaderCell onClick={() => requestSort("name", "string", "name", setCurrentSortName, setSortIcon, setSortOrder, sortOrder, setThemes, themes, false)}>
                                Name{currentSortName === "name" ? <Icon name={sortIcon} /> : <Icon name={SORT_ICON.DEFAULT} />}</Table.HeaderCell>
                            <Table.HeaderCell>Type</Table.HeaderCell>
                            <Table.HeaderCell>Actions</Table.HeaderCell>
                        </Table.Row>
                    </Table.Header>
                    <Table.Body>
                        {themes.map(function (theme: ITheme) {
                            return (
                                <Table.Row key={theme.id}>
                                    <Table.Cell> {theme.name}</Table.Cell>
                                    <Table.Cell>
                                    <span>
                                            {theme.customPath === null ? "Standard" : "Custom"}
                                    </span>
                                    </Table.Cell>
                                    <Table.Cell>
                                        {(theme.id !== "Default" && theme.customPath === null) && (
                                            <>
                                                <a><Popup content="Edit theme" trigger={<Icon name="pencil alternate" alt='Edit Theme' id='edit' style={{ cursor: 'pointer' }} onClick={() => history.push({ pathname: '/CM2WebShare/ThemeSettings', search: `?id=${theme.id}` })} />} /></a>
                                            </>
                                        )}

                                        {(theme.id !== "Default") && (
                                            <>
                                                <a><Popup content="Delete theme" trigger={<Icon name="trash alternate outline" alt='Delete Theme' id='delete' style={{ cursor: 'pointer' }} onClick={() => deleteTheme(theme.id)} />} /></a>
                                            </> 
                                        )}
                                    </Table.Cell>
                                </Table.Row>
                            )
                        })}
                    </Table.Body>
                </Table>
                <div className="resultsNav" style={{ marginTop: "20px", paddingBottom: "20px" }}>
                    <PaginationNav totalPages={totalPages} onChange={handlePaginationChange} activePage={activePage} />
                </div>

                <div style={{ display: "flex", alignItems: "flex-end", justifyContent: "left", alignContent: "stretch", margin: 10 }}>
                    <Button id="new-table" onClick={() => history.push("/CM2WebShare/ThemeSettings")}>Create New Theme</Button>
                    <Button id="upload-table" onClick={() => history.push("/CM2WebShare/UploadTheme")}>Upload Custom Theme</Button>
                </div>
            </div>
        );
    } 
}

export default ThemeDisplay;